module.exports = __webpack_public_path__ + "static/media/micunmute.d15ab7f5.svg";